const Colors = {
  ocdGreen: '#0cd0cd',
  ocdWhite: '#fbfefe',
  mintCream: 'f1fefe',
  celeste: '#c5fcfb',
  skobeloff: '#146362',
  darkJungleGreen: '#0e2b2b',
  richBlack: '#010d0d',
  nickel: '#6b7171',
  silverSand: '#bdc2c2',
  lightGray: '#f4f4f9'
};

export { Colors };
